import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ModalRestaurarCopiaMigracion from '../../components/copiaSeguridad/ModalRestaurarCopiaMigracion'
import {cerrarModalRestaurarMigracion, subirArchivosCopiaSeguridad, submitRestaurarMigracion} from '../../actions/copiaSeguridad/copiaSeguridad'

export function mapStateToProps (state) {
  return {
    ...state.copiaSeguridad,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      cerrarModalRestaurarMigracion,
      subirArchivosCopiaSeguridad,
      submitRestaurarMigracion
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalRestaurarCopiaMigracion))